import { posImageAxiosClient } from '@kinderlabs-pos/apis/axios';

export const createImageUploadAsync = (rootUrl: string) => async (formData: FormData) => {
	return (await posImageAxiosClient.post<any>(`${rootUrl}/store/file`, formData)).data;
};
